export const EMAIL_BLACKLIST = [
  'test.device@nordeus.com',
]

export function isEmailBlacklisted(email) {
  return EMAIL_BLACKLIST.includes(email.toLowerCase())
}
